import { React } from 'react';
import ServiceSection from '../../../../ServiceSection/ServiceSection';
import SatelliteText from '../../../SatelliteText/SatelliteText';
import satelliteIcon from '../../../satelliteIcon';

const ReduceAbsenteeism3 = props => (
    <ServiceSection noPadBottom noPadTitle singleTitle icon={satelliteIcon} {...props} page="reduceAbsenteeism" section="manualControl">
        <div className='TextGroup Satellite'>
            <div className='container-custom subtitle'>
                <SatelliteText t={props.t} prefix="reduceAbsenteeism:manualControl" first noPadBottom />
            </div>
        </div>
    </ServiceSection>
);

export default ReduceAbsenteeism3;
